import React from "react"

function SafeReward() {
    
    return (
        <div className="safeRewardWrapper">
            <h3>Why does Nigel have information regarding fingerprints in his safe? Some might call it suspicious, but right now I call it lucky! We can use this to help finish our fingerprint analysis</h3>
            
            <div className="imageTextWrapper" id="safeRewardImage">
                <img src={"images/partThree/fifthFinger.jpg"} alt="information to help decode the fifth finger" />
            </div>
            <br/><br/>
        </div>
    )
}

export default SafeReward